import { type ReactElement } from 'react';
import { ENFORCEMENT_LABELS, ENFORCEMENT_TITLES } from '@/lib/validation-rule-enforcement';

// Validation Rules rows 1–2 (item 9) — what the rule's CODE does, from the
// server's Enforcement (derived from the implementation, never the row text).
// "Not yet enforced" is styled so it can never pass for an enforced error; a
// value the server did not send renders "Enforcement unknown", never a blank.
export function EnforcementBadge({ enforcement }: { enforcement: string | undefined }): ReactElement {
  const known = enforcement !== undefined && enforcement in ENFORCEMENT_LABELS;
  const value = known ? enforcement : 'unknown';
  const style =
    value === 'enforced'
      ? { background: '#dcfce7', color: '#14532d', border: '1px solid #86efac' }
      : value === 'advisory'
        ? { background: '#fef3c7', color: '#78350f', border: '1px solid #fcd34d' }
        : { background: 'var(--surface2, #f3f4f6)', color: 'var(--text-muted)', border: '1px dashed var(--border)' };
  return (
    <span
      data-enforcement={value}
      title={known ? ENFORCEMENT_TITLES[value] : 'Enforcement status not reported by the server'}
      style={{ display: 'inline-block', padding: '1px 7px', borderRadius: 999, fontSize: 10, fontWeight: 700, whiteSpace: 'nowrap', ...style }}
    >
      {known ? ENFORCEMENT_LABELS[value] : 'Enforcement unknown'}
    </span>
  );
}
